import * as Yup from 'yup';

const LoginSchema = Yup.object().shape({
    email: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
    password: Yup.string()
        // .min(8, 'Too short')
        .max(30, 'Too long')
        .required('Password is required'),
});


const LoginOTPSchema = Yup.object().shape({
    otp: Yup.string()
        .required('One time password is required'),
});

const UpdatePasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
        .trim()
        .min(8, 'Too short minimum 8 characters')
        .max(30, 'Too long maximum 30 characters')
        .required('New password is required'),
    newPasswordConfirm: Yup.string()
        .trim()
        .min(8, 'Too short minimum 8 characters')
        .max(30, 'Too long maximum 30 characters')
        .required('New password confirmation is required'),
});

export {
    LoginSchema,
    LoginOTPSchema,
    UpdatePasswordSchema
};
